import React, { useMemo } from 'react';
import { Text, StyleSheet } from 'react-native';
import { usePaymentDesignTokens, PAYMENT_TYPOGRAPHY } from '@/constants/residents/mobile/paymentDesignTokens';
import { mobilePaymentsStrings } from '@/constants/residents/strings';
import { PaymentBottomSheet } from './PaymentBottomSheet';

export type BalanceState = 'owed' | 'zero' | 'credit' | 'past_due';

interface PaymentInfoBubbleModalProps {
  visible: boolean;
  onClose: () => void;
  balanceState: BalanceState;
}

const INFO_CONTENT: Record<BalanceState, { title: string; description: string }> = {
  owed: {
    title: mobilePaymentsStrings.infoBubbleOwedTitle,
    description: mobilePaymentsStrings.infoBubbleOwedDesc,
  },
  zero: {
    title: mobilePaymentsStrings.infoBubbleZeroTitle,
    description: mobilePaymentsStrings.infoBubbleZeroDesc,
  },
  credit: {
    title: mobilePaymentsStrings.infoBubbleCreditTitle,
    description: mobilePaymentsStrings.infoBubbleCreditDesc,
  },
  past_due: {
    title: mobilePaymentsStrings.infoBubblePastDueTitle,
    description: mobilePaymentsStrings.infoBubblePastDueDesc,
  },
};

/**
 * Payment Info Bubble Modal
 * Bottom sheet that explains the balance state
 * Matches Figma designs 6, 6.a, 6.b, 6.c
 */
export const PaymentInfoBubbleModal: React.FC<PaymentInfoBubbleModalProps> = ({
  visible,
  onClose,
  balanceState,
}) => {
  const pt = usePaymentDesignTokens();

  const styles = useMemo(() => StyleSheet.create({
    descriptionText: {
      ...PAYMENT_TYPOGRAPHY.bodySm,
      color: pt.TEXT_SECONDARY,
      lineHeight: 21,
    },
}), [pt]);

  const content = INFO_CONTENT[balanceState];

  return (
    <PaymentBottomSheet
      visible={visible}
      onClose={onClose}
      title={content.title}
    >
          <Text style={styles.descriptionText}>
            {content.description}
          </Text>
    </PaymentBottomSheet>
  );
};

